export default "__VITE_ASSET__Cst1IYkQ__"